import { Link, NavLink } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useNavItems } from "./nav";
import { AssocLogo } from "./AssocLogo";

export const NavList = ({ onNavigate, prefix = "sidebar" }) => {
  const { can, user } = useAuth();
  return (
    <nav className="space-y-1">
      {useNavItems(can, user).map(({ to, label, icon: Icon }) => (
        <NavLink
          key={to}
          to={to}
          end={to === "/"}
          onClick={onNavigate}
          data-testid={`${prefix}-link-${to === "/" ? "home" : to.slice(1)}`}
          className={({ isActive }) =>
            `flex items-center gap-3 rounded-lg px-3 min-h-[44px] text-[15px] transition-colors ${isActive ? "bg-primary/10 text-primary font-semibold" : "text-slate-700 hover:bg-slate-100"}`
          }
        >
          <Icon className="h-5 w-5 shrink-0" />
          {label}
        </NavLink>
      ))}
    </nav>
  );
};

export const Copyright = ({ className = "px-5 py-3 border-t border-slate-200" }) => (
  <div data-testid="copyright" className={`text-xs text-slate-500 ${className}`}>© {new Date().getFullYear()} Opale Group · <Link to="/note-legali" data-testid="footer-legal-link" className="underline hover:text-slate-600">Privacy e note legali</Link></div>
);

export const Sidebar = () => {
  const { assoc } = useAuth();
  return (
    <aside data-testid="sidebar" className="hidden lg:flex w-64 shrink-0 flex-col border-r border-slate-200 bg-white h-screen sticky top-0">
      <div className="flex items-center gap-3 px-5 h-20 border-b border-slate-200">
        <AssocLogo />
        <div className="min-w-0">
          <div className="font-heading font-bold text-slate-900 leading-tight truncate">{assoc?.name}</div>
          <div className="text-xs text-slate-500">Insieme</div>
        </div>
      </div>
      <div className="flex-1 overflow-y-auto p-3">
        <NavList />
      </div>
      <Copyright />
    </aside>
  );
};
